import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import request from "../../../app/api/requests";
import { useNavigate } from "react-router-dom";
import '../lib/RegisterApp.css';
import { sendDataLayer } from "../../../shared/lib/sendDataLayer";
import { startSession } from '../../../shared/lib/auth/session';
import Validation from "../../../shared/ui/Validation/Validation";
import useTimeZone from "../../../shared/hooks/useTimeZone";
import { useDispatch } from "react-redux";
import { ReactComponent as UserEmail } from "../../../shared/lib/icons/svg/Feedback/email.svg";
import { ReactComponent as UserPass } from "../../../shared/lib/icons/svg/Feedback/pass.svg";
import { ReactComponent as UserLogo } from "../../../shared/lib/icons/svg/Feedback/user.svg";
import DefaultInput from "../../../shared/ui/DefaultInput/DefaultInput";
import { getUserData } from "../../../features/user/getUserData";
import { Button } from "../../../shared/ui/Button";


export default function RegisterUser() {
  const dispatch = useDispatch();
  const [firstname, setFirstName] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(true);
  const [checkedPrivacy, setCheckedPrivacy] = useState(true);
  const [loading, setLoading] = useState(false);
  const focusEmail = document.getElementById('email')
  const focusPassword = document.getElementById('password')
  const [errorPasswordNotMatch, setErrorPasswordNotMatch ] = useState(true);
  const [errorPasswordUpperCase, setErrorPasswordUpperCase] = useState(true);
  const [errorPasswordLowerCase, setErrorPasswordLowerCase] = useState(true);
  const [errorPasswordDigitCase, setErrorPasswordDigitCase] = useState(true);
  const [errorPasswordLength, setErrorPasswordLength] = useState(true);
  const { getCurrentTimeZone } = useTimeZone()
  // const [isUpperCase, setIsUpperCase] = useState(false);
  // const [isLowerCase, setIsLowerCase] = useState(false);
  // const [isDigitCase, setIsDigitCase] = useState(false);
  // const [isLength, setIsLength] = useState(false);
  let arrErrors = new Array([]);
  const [dataErrors, setDataErrors] = useState([]);
  let regexpToLowerCase = /[а-яa-z]/gu // eslint-disable-line
  let regexpToUpperCase = /[А-ЯA-Z]/gu // eslint-disable-line
  let regexpToDigitCase = /[\p{Nd}]/gu // eslint-disable-line
  let emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/ // eslint-disable-line
  /* eslint-disable-next-line */

  useEffect(() => {
    if (localStorage.getItem('userID')) {
      navigate('/', { replace: true })
    }
  })

  function handleRegister() {
    // setIsUpperCase(false)
    // setIsLowerCase(false)
    // setIsDigitCase(false)
    // setIsLength(false)
    setDataErrors([])
    request.post('/Account/Register', {
      firstName: firstname,
      email: email,
      password: password,
      passwordConfirm: passwordConfirm,
      timeZoneId: getCurrentTimeZone()
    })
    .then(res => {
      setLoading(false)
      if (res.status === 200) {
        sendDataLayer('registration', 'registration')
        localStorage.setItem('userID', res.data.id);
        localStorage.setItem('authToken', res.data.token);
        localStorage.setItem('firstName', res.data.firsName);
        localStorage.setItem('lastName', res.data.lastName === null ? '' : res.data.lastName);
        localStorage.setItem('interceptorTry', 'false');
        startSession(res.data.token, res.data.refreshToken);
        dispatch(getUserData()).then(() => {
          navigate('/register_success', { replace: true });
        })
        // dispatch({type: UserAuthActionTypes.FETCH_DATA_RESPONSE_USER_ACCOUNT})
        // dispatch(loginUser({id: res.data.id, firsName: res.data.firsName , lastName: res.data.lastName}))
        
      }
    })
    .catch((error) => {
      setLoading(false)
      if(error.response.data.errors.Email != null){
        let arrGetError = Object.entries(error.response.data.errors)
        arrGetError.forEach(([key, value]) => {
          value.map(err => arrErrors.push({key, err}))
          setDataErrors(arrErrors)
        })
      }
    })
  }

  useEffect(() => {
    if ((firstname !== '') && (email !== '') && (password !== '') && (passwordConfirm !== '') && (errorPasswordNotMatch) && (checkedPrivacy === true)) {
        setIsDisabled(false)
    } else {
      setIsDisabled(true)
    }
  }, [firstname, email, password, passwordConfirm, errorPasswordNotMatch, checkedPrivacy])

  useEffect(() => {
    if ((passwordConfirm !== password) && (passwordConfirm !== '')) {
      setErrorPasswordNotMatch(false)
    } else {
      setErrorPasswordNotMatch(true)
    }
  }, [passwordConfirm, password])

  useEffect(() => {
    /* eslint-disable-next-line */
    if (!errorPasswordDigitCase || !errorPasswordLength || !errorPasswordLowerCase || !errorPasswordUpperCase) {
      /* eslint-disable-next-line */
      checkPassword(password)
    }
    /* eslint-disable-next-line */
  }, [password])

  function checkRepeatPassword(value) {
    setPasswordConfirm(value)
    if ((value !== password) && (value !== '')) {
        setErrorPasswordNotMatch(false)
    } else (
        setErrorPasswordNotMatch(true)
    )
  }

  function checkPassword(value) {
    setLoading(false)
    toLowerCase(value)
    toUpperCase(value)
    toDigitCase(value) 
    toLengthPassword(value)
  }

  function toLowerCase(value) {
    if (regexpToLowerCase.test(value) === true) {
        setErrorPasswordLowerCase(true)
        // setIsLowerCase(true);
    } else {
        setErrorPasswordLowerCase(false)
        // setIsLowerCase(false)
    }
}

function toUpperCase(value) {
    if (regexpToUpperCase.test(value) === true) {
        setErrorPasswordUpperCase(true)
        // setIsUpperCase(true)
    } else  {
        setErrorPasswordUpperCase(false)
        // setIsUpperCase(false)
        focusPassword.focus()
    }
}

function toDigitCase(value) {
    if (regexpToDigitCase.test(value) === true) {
        setErrorPasswordDigitCase(true)
        // setIsDigitCase(true)
    } else {
        setErrorPasswordDigitCase(false)
        // setIsDigitCase(false)
    }
}

function toLengthPassword(value) {
    if (value.length >= 6) {
        setErrorPasswordLength(true)
        // setIsLength(true)
    } else {
        setErrorPasswordLength(false)
        // setIsLength(false)
    }
}

  function handleSubmit(e) {
    // e.preventDefault();
    if (emailReg.test(email) === true) {
      setLoading(true)
      checkPassword(password)
      setDataErrors([])
      handleRegister()
    } else {
      arrErrors.push({key: 'Email', err: 'некорректный email'});
      setDataErrors(arrErrors)
      focusEmail.focus();
    }
  }

  return (
    <div className="register-form__page">
      <div className="register-form__container">
        <h2 className="register-form__heading">Регистрация аккаунта</h2>
        <form onSubmit={handleSubmit} autoSave="off" className='register-form__form'>
          <ul className="register-from__list">
            <li className="register-form__list__item">
              <DefaultInput logo={<UserLogo />} 
                inputType="text"
                autoComplete="given-name" 
                placeHolder="Имя" 
                inputValue={firstname}  
                onChangeFunc={(value) => setFirstName(value)} 
              />
            </li>
            <li className="register-form__list__item">
              <DefaultInput logo={<UserEmail />} 
                placeHolder="E-mail"
                autoComplete="off" 
                inputType="email" 
                inputValue={email} 
                onChangeFunc={setEmail}>
                <Validation data={dataErrors} keyItem={'Email'}/>
              </DefaultInput>
            </li>
            <li className="register-form__list__item">
              <DefaultInput  placeHolder="Пароль"
                logo={<UserPass />} 
                inputType="password"
                autoComplete="new-password" 
                inputValue={password} 
                onChangeFunc={setPassword}>
                <p className={errorPasswordUpperCase ? 'hide' : 'error-change-email'}>* требуются буквы в верхнем регистре</p>
                <p className={errorPasswordLowerCase ? 'hide' : 'error-change-email'}>* требуются буквы в нижнем регистре</p>
                <p className={errorPasswordDigitCase ? 'hide' : 'error-change-email'}>* требуются цифры</p>
                <p className={errorPasswordLength ? 'hide' : 'error-change-email'}>* длина пароля минимум 6 символов</p>
              </DefaultInput>
            </li>
            <li className="register-form__list__item">
              <DefaultInput placeHolder="Подтверждение пароля"
                logo={<UserPass />}  
                inputType="password"
                autoComplete="new-password" 
                inputValue={passwordConfirm} 
                onChangeFunc={(value) => checkRepeatPassword(value)}>
                <p className={errorPasswordNotMatch ? 'hide' : 'error-change-email'}>* не совпадают Пароли</p>
              </DefaultInput>
            </li>
          </ul>
          <Button 
            title="Зарегистрироваться"
            loading={loading}
            onClickFunc={(e) => handleSubmit(e)}
            disabled={isDisabled}
            btnType="filled"
            btnSize="xl"
          />
          <div className="privacy-check checkList">
            <label className="label_to_checkBox privacy-label" style={{alignItems: 'center'}}>
              <input type="checkbox" className="checkList_checkbox" checked={checkedPrivacy} onClick={() => setCheckedPrivacy(!checkedPrivacy)}/>
              <span></span>
              Я принимаю 
              <a href="https://timetask.ru/privacy" rel="noreferrer" className="privacy-link" target="_blank" style={{marginLeft: '3px'}}>Политику конфиденциальности</a> 
            </label>
          </div>
          <p className="login-description">
            Уже есть аккаунт? <Link to="/login/">Вход</Link>
          </p>
        </form>
      </div>
    </div>

  )
}
